import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c2ff634"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "toggle-switch",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args)))
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      class: "switch",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isChecked) = $event))
    }, null, 512), [
      [_vModelCheckbox, _ctx.isChecked]
    ]),
    _hoisted_1,
    _createElementVNode("i", {
      class: _normalizeClass(["fas", _ctx.isChecked ? 'fa-sun flip' : 'fa-moon'])
    }, null, 2)
  ]))
}